export const AVATAR_IMAGE_ACCEPT = 'image/*'
export const AVATAR_IMAGE_ERROR = 'Choose an image file, including GIF.'

interface AvatarFile {
    type?: string
}

export function isAvatarImageFile(file: AvatarFile | string | null | undefined): boolean {
    return typeof file !== 'string' && Boolean(file?.type?.toLowerCase().startsWith('image/'))
}
